/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestsempty1Inputs */

const en_requestsempty1 = /** @type {(inputs: Requestsempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing here right now.`)
};

const de_requestsempty1 = /** @type {(inputs: Requestsempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier ist gerade nichts.`)
};

/**
* | output |
* | --- |
* | "Nothing here right now." |
*
* @param {Requestsempty1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestsempty1 = /** @type {((inputs?: Requestsempty1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestsempty1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestsempty1(inputs)
	return de_requestsempty1(inputs)
});
export { requestsempty1 as "requestsEmpty" }